import { render } from "./Room.vue?vue&type=template&id=15b410da"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
script.render = render

export default script